import React, { useState, useContext } from "react"

import Layout from "../components/layout"
import SEO from "../components/seo"
import ContactNav from "../components/contact-nav"
import LocationsMap from "../components/locations-map"
import Navigation from "../components/navigation"
import useRedirectToLang from "../hooks/useRedirectToLang"
import useTime from "../hooks/useTime"
import { ViewportContext } from "../contexts/viewport-context"

const ContactPage = () => {
  useRedirectToLang("/en/contact")
  const dimensions = useContext(ViewportContext)
  const time = useTime()
  const [state, setState] = useState("Berlin")

  const handleButtonClick = wantedState => {
    if (state !== wantedState) setState(wantedState)
  }

  return (
    <>
      <SEO title="Contact Us" lang="en" />
      <Layout width={dimensions[0]}>
        <div className="contact-page">
          <section>
            <LocationsMap locationsState={state} lang="en" />
          </section>
          <section>
            <ContactNav
              navState={state}
              buttonClick={handleButtonClick}
              lang="en"
            />
            <h1>
              Berlin
              <br />
              {time[0]}
            </h1>
            <h6>
              Oranienstraße 183
              <br />
              10999 Berlin, Germany
            </h6>
            <h1>
              Shanghai
              <br />
              {time[1]}
            </h1>
            <h6>
              No. 141 Yanqing Road
              <br />
              200031 Shanghai, China
            </h6>
            <h6>
              <a
                href="mailto:hello@senses-integration.com"
                rel="noreferrer"
                target="_blank"
              >
                hello@senses-integration.com
              </a>
            </h6>
          </section>
        </div>
      </Layout>
      <Navigation path="/en/contact" lang="en" width={dimensions[0]} />
    </>
  )
}

export default ContactPage
